__webpack_require__.p = "https://assets-01.periodica.press/40040ff-26825747179/";